
export const isServiceWorkerInitialized = (state) => state.version.serviceWorkerInitialized;
export const isServiceWorkerUpdated = (state) => state.version.serviceWorkerUpdated;
export const serviceWorkerRegistration = (state) => state.version.serviceWorkerRegistration;
